import React from 'react';
import { useRef} from 'react';
import { useInView } from 'react-intersection-observer';
import "./AboutMeSection.css"
import JapanPhoto from './../../images/japan-photo.png';

const AboutMeSection = () => {
    const { ref: myRef, inView: aboutVisible} = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });
    const { ref: titleRef, inView: titleVisible} = useInView({
        triggerOnce: true,
        threshold: 1,
    });

    return(
        <div class="about__tile" >
            <section ref={myRef} class="about-me" id="about">
                <h2 ref={titleRef} class={`section__title section__title--about ${titleVisible ? "show":""}`}>Who I am</h2>
                <p class={`section__subtitle section__subtitle--about ${aboutVisible ? "show":""}`}>Vietnamese American Software Engineer</p>
                
                <div class={`about-me__body ${aboutVisible ? "show":""}`}>
                    <p>I'm a first gen student who has grown up in Florida for a majority of my life. I immigrated over to the United States when I was four and have since
                        become a naturalized citizen of the United States. I started my professional career with Capital One and currently living in Dallas, TX.
                    </p>
                    <p>Technically, I started as a front-end enthusiast, but joining Capital One’s TDP program gave me the chance to pivot. I took a leap into backend development and never looked back. There is something deeply rewarding to me about the "brain-teasers" found in distributed systems.
                    </p>
                    <p>In my free time I enjoy playing guitar, collecting pokemon cards, and playing golf!
                    </p>
                </div>
                <img src={JapanPhoto} alt="photo of me in Japan" class={`about-me__img ${aboutVisible ? "show":""}`}/>
            </section>
        </div>

    )
}

export default AboutMeSection;